import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  listKitchenFoods: 'techsavanna_pos.api.kitchen.list_kitchen_foods',
  createKitchenFood: 'techsavanna_pos.api.kitchen.create_kitchen_food',
  listFactors: 'techsavanna_pos.api.kitchen.list_factors_of_production',
  createFactor: 'techsavanna_pos.api.kitchen.create_factor_of_production',
  updateFactor: 'techsavanna_pos.api.kitchen.update_factor_of_production',
  productionMonitor: 'techsavanna_pos.api.kitchen.get_production_monitor',
  getUoms: 'techsavanna_pos.api.kitchen_uom_api.get_kitchen_uoms',
  createUom: 'techsavanna_pos.api.kitchen_uom_api.create_kitchen_uom',
  updateUom: 'techsavanna_pos.api.kitchen_uom_api.update_kitchen_uom',
};

// Normalise a Frappe response body (success or 409 error) into a plain object.
const readUomResult = (body) => {
  const m = body?.message;
  if (m && typeof m === 'object') return m;
  if (m) return { success: false, message: m };
  return body || { success: false, message: 'Failed to create unit of measurement' };
};

const kitchenService = {
  listKitchenFoods: async (params = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.listKitchenFoods, { params });
    const d = response?.data?.message || response?.data;
    return {
      foods: d?.foods || d?.data || [],
      total: d?.total ?? 0,
    };
  },

  createKitchenFood: async (payload) => {
    const response = await axiosInstance.post(ENDPOINTS.createKitchenFood, payload);
    return response?.data?.message || response?.data;
  },

  listFactors: async (params = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.listFactors, { params });
    const d = response?.data?.message || response?.data;
    return {
      factors: d?.factors || d?.data || [],
      total: d?.total ?? 0,
    };
  },

  createFactor: async (payload) => {
    const response = await axiosInstance.post(ENDPOINTS.createFactor, payload);
    return response?.data?.message || response?.data;
  },

  updateFactor: async (payload) => {
    const response = await axiosInstance.post(ENDPOINTS.updateFactor, payload);
    return response?.data?.message || response?.data;
  },

  getProductionMonitor: async (params = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.productionMonitor, { params });
    const d = response?.data?.message || response?.data;
    return d?.rows || d?.data || [];
  },

  getUoms: async () => {
    const response = await axiosInstance.get(ENDPOINTS.getUoms);
    const d = response?.data?.message || response?.data;
    return d?.uoms || [];
  },

  // Create a UOM. The backend rejects names that collide with an existing UOM
  // (returns { success:false, existing_uom }); we surface that to the caller
  // instead of throwing so it can reuse the existing unit.
  createUom: async (uomName, mustBeWhole = false) => {
    try {
      const res = await axiosInstance.post(ENDPOINTS.createUom, {
        uom_name: uomName,
        must_be_whole_number: mustBeWhole ? 1 : 0,
      });
      return readUomResult(res?.data);
    } catch (error) {
      return readUomResult(error?.response?.data);
    }
  },

  updateUom: async (name, newUomName, mustBeWhole) => {
    try {
      const res = await axiosInstance.post(ENDPOINTS.updateUom, {
        name,
        new_uom_name: newUomName,
        must_be_whole_number: mustBeWhole ? 1 : 0,
      });
      return readUomResult(res?.data);
    } catch (error) {
      return readUomResult(error?.response?.data);
    }
  },
};

export default kitchenService;
